// 规则类型
export const InsuranceType = {
  NONE: 0,
  ALL: 3, // 同时
  ADULT: 1, // 成人
  CHILD: 2 // 儿童
}
